// extracted by mini-css-extract-plugin
export default {"container":"title_container__2VBho","title":"title_title__3S4b9","small":"title_small__3FdKq","padded":"title_padded__3wklf","inner":"title_inner__2Usgr"};